module.exports = __webpack_public_path__ + "static/img/yeswecan0036.c10d64c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0036.png
// module id = 611
// module chunks = 1